// extracted by mini-css-extract-plugin
export default {"choose-order-type":"choose-order-type_choose-order-type__vRHbl","choose-order-type-button":"choose-order-type_choose-order-type-button__vCaLg"};